import { AlertEnum } from '../enumerators/messages.enum';

export class Alert {
    public remove: boolean = true;
    public description: string = "";
    public type: AlertEnum = AlertEnum.Success;
    public alertId: number = 0;
    public icon: string = "";
    public class: string = "";
    public animation: string = "slideInUp";
    public timer: number = 0;

    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);
    }

}
